var HeadingSectionHeaderBackgroundColor;
(function (HeadingSectionHeaderBackgroundColor) {
    HeadingSectionHeaderBackgroundColor["GREY"] = "gray";
    HeadingSectionHeaderBackgroundColor["NONE"] = "none";
    HeadingSectionHeaderBackgroundColor["WHITE"] = "white";
})(HeadingSectionHeaderBackgroundColor || (HeadingSectionHeaderBackgroundColor = {}));
export { HeadingSectionHeaderBackgroundColor, };
//# sourceMappingURL=heading-section-constants.js.map